export default __webpack_public_path__ + "static/media/discussion_icon_white.4899f66d.svg";